export default __webpack_public_path__ + "static/media/cinema.d82b38a2.svg";